const SFX_BASE =
  "https://img.securedataimages.com/images/cams/cams2/images/emojis/sfx_files";

export const EMOJI_SFX_MAP: Record<string, string> = {
  virtual_gift_emoji_hot: `${SFX_BASE}/HOT/hotSFX.wav`,
  virtual_gift_emoji_hug: `${SFX_BASE}/HUG/hugSFX.wav`,
  virtual_gift_emoji_kiss: `${SFX_BASE}/KISS/kissSFX.wav`,
  virtual_gift_emoji_heart: `${SFX_BASE}/HEART/heartSFX.wav`,
  virtual_gift_emoji_eggplant: `${SFX_BASE}/EGGPLANT/eggplantSFX.wav`,
  virtual_gift_emoji_melons: `${SFX_BASE}/MELONS/melonsSFX.wav`,
  virtual_gift_emoji_banana2: `${SFX_BASE}/BANANA/bananaSFX.wav`,
  virtual_gift_emoji_drool: `${SFX_BASE}/DROOL/emoji_drool_sfx.wav`,
  virtual_gift_emoji_cherries: `${SFX_BASE}/CHERRIES/emoji_cherries_sfx.wav`,
  virtual_gift_emoji_lick: `${SFX_BASE}/LICKING/lickingSFX.wav`,
  virtual_gift_emoji_peach: `${SFX_BASE}/PEACH/peachSFX.wav`,
  virtual_gift_emoji_wolf: `${SFX_BASE}/WOLF/wolfSFX.wav`,
  virtual_gift_emoji_lightning: `${SFX_BASE}/LIGHTNING/emoji_lightning_sfx.wav`,
  virtual_gift_emoji_volcano: `${SFX_BASE}/VOLCANO/emoji_volcano_sfx.wav`,
  virtual_gift_emoji_eggplantrocket: `${SFX_BASE}/ROCKET/rocketSFX.wav`,
  virtual_gift_emoji_ghost: `${SFX_BASE}/GHOST/ghostSFX.wav`,
  virtual_gift_emoji_turkey: `${SFX_BASE}/TURKEY/turkeySFX.wav`,
  virtual_gift_emoji_train: `${SFX_BASE}/TRAIN/trainSFX.wav`,
};

export const isEmojiGift = (giftName: string): boolean => {
  return giftName in EMOJI_SFX_MAP;
};
